import React, { Fragment, useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import axios from "axios"; //axios instance;
import AppBar from "../../components/Frontend/AppBar/AppBar";
import Spinner from "../../UI/Spinner/Spinner";
import DoneIcon from "@material-ui/icons/Done";
import { styled } from "@material-ui/core";
import { Cities } from "../../config/jobsConfigData";
import SendFill from "../../Assets/CustomIcons/SendFill";
import CloseRoundedIcon from "@material-ui/icons/CloseRounded";
import { FormattedMessage, useIntl } from "react-intl";
import {
  Typography,
  Box,
  Container,
  Chip,
  Avatar,
  makeStyles,
  TextField,
  useTheme,
  Button,
  Snackbar,
  Slide,
  Divider,
  IconButton,
} from "@material-ui/core";
import { Autocomplete, Alert } from "@material-ui/lab";
import AxiosErrorHandling from "../../components/AxiosErrorHandling/AxiosErrorHandling";
import { CategoriesMapping } from "../../config/jobsConfigData";

const styles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#f2f2f2",
    //margin: "auto",
    minHeight: "100vh",
    overflow: "hidden",
    "& .MuiChip-root": {
      marginRight: theme.spacing(2),
      fontSize: "1rem",
    },
    "& .MuiAutocomplete-root": {
      backgroundColor: "#fff",
    },
  },
}));

const UnchckedChip = styled(({ type, ...other }) => <Chip {...other} />)({
  border: "1px solid #A4A6B3",
  color: "#A4A6B3",
  "& .MuiSvgIcon-root": {
    color: "#A4A6B3",
  },
});

const SingalPreferences = (props) => {
  const classes = styles();
  const theme = useTheme();
  const intl = useIntl();
  const [error, setError] = useState(null);
  const [companyData, setCompanyData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showCategoriesHelp, setShowCategoriesHelp] = useState(false);
  const [updatedSuccessfully, setUpdatedSuccessfully] = useState(false);
  useEffect(() => {
    //get token
    const token = props.match.params.token;

    const getCompanyData = async () => {
      try {
        setIsLoading(true);
        const data = await axios.get(
          `/wp-json/api/v2/company_signal_preferences/${token}`
        );
        setCompanyData(data.data);
        setIsLoading(false);
      } catch (err) {
        setError(err.response);
        setIsLoading(false);
        updatedSuccessfully(false);
      }
    };
    getCompanyData();
  }, []);

  const handleCityChange = (event, value, reason) => {
    setCompanyData({ ...companyData, cities: value });
  };

  const handleCategoryClick = (category) => {
    const localCatgories = companyData.categories;
    const catIndex = localCatgories.findIndex((cat) => cat.id === category);
    if (catIndex > -1) {
      localCatgories[catIndex].selected = !localCatgories[catIndex].selected;
      setCompanyData({ ...companyData, categories: localCatgories });
    }
  };

  const handlePostPreferences = async () => {
    const localCategories = companyData.categories
      .filter((cat) => cat.selected)
      .map((cat) => cat.id);
    const preferences = {
      cities: companyData.cities,
      categories: localCategories,
    };
    try {
      setIsLoading(false);
      const res = await axios.post(
        `/wp-json/api/v2/company_signal_preferences/${companyData.company_id}`,
        { preferences },
        {
          headers: { Authorization: `Bearer ${props.match.params.token}` },
        }
      );
      setUpdatedSuccessfully(true);
    } catch (err) {
      setError(err.response);
      setIsLoading(false);
      setUpdatedSuccessfully(false);
    }
  };
  function getPreferredLang(locale) {
    switch (locale) {
      case "en-US":
        return "en";
      case "el-GR":
        return "gr";
      default:
        return "en";
    }
  }

  return (
    <Container maxWidth="sm" className={classes.root} disableGutters>
      <AppBar preferredLanguage={getPreferredLang(intl.locale)} />

      {error && (
        <AxiosErrorHandling error={error} title="Oh no! We have a problem" />
      )}
      {isLoading ? (
        <Spinner open={isLoading} />
      ) : (
        <Fragment>
          {showCategoriesHelp ? (
            <CategoriesHelp
              open={showCategoriesHelp}
              onClose={() => setShowCategoriesHelp(false)}
              categories={companyData.categories}
            />
          ) : (
            <Box my={2} p={2}>
              <Typography variant="subtitle1" paragraph>
                <FormattedMessage
                  id="signalPreferences.welcom"
                  defaultMessage="Hello {fullname}, we are pleased to have you onboard with us!"
                  values={{ fullname: companyData ? companyData.fullname : "" }}
                />
              </Typography>
              <Typography variant="body1">
                <FormattedMessage
                  id="signalPreferences.welcomDescription"
                  defaultMessage="In order to provide you with the vest suitable candidates, please let us know WHO you are looking for and WHERE"
                />
              </Typography>
              <Box my={2}>
                <Typography variant="subtitle1">
                  <FormattedMessage
                    id="signalPreferences.categoriesTitle"
                    defaultMessage={"Select employee categories"}
                  />
                </Typography>
                <Typography variant="body1">
                  <FormattedMessage
                    id="signalPreferences.categoriesDescription"
                    defaultMessage="What employees are you looking for?"
                  />
                </Typography>
              </Box>
              <Box my={2}>
                {companyData &&
                  companyData.categories.map((cat) => {
                    const chipProps = {
                      label: intl.formatMessage({
                        id: `signalCategory.${cat.id}`,
                        defaultMessage: cat.name,
                      }),
                      avatar: <Avatar alt={cat.name} src={cat.icon} />,
                      key: cat.id,
                      variant: "outlined",
                      clickable: true,
                      color: "primary",
                      onClick: () => handleCategoryClick(cat.id),
                      onDelete: () => handleCategoryClick(cat.id),
                    };
                    return cat.selected ? (
                      <Chip
                        {...chipProps}
                        deleteIcon={<DoneIcon />}
                        style={{ marginBottom: theme.spacing(2) }}
                      />
                    ) : (
                      <UnchckedChip
                        {...chipProps}
                        style={{ marginBottom: theme.spacing(2) }}
                      />
                    );
                  })}
              </Box>
              <Box my={2}>
                <Typography
                  variant="subtitle1"
                  color="secondary"
                  style={{ textDecoration: "underline", cursor: "pointer" }}
                  onClick={() => setShowCategoriesHelp((prev) => !prev)}
                >
                  Not sure what categories you need?
                </Typography>
              </Box>
              <Box my={2}>
                <Typography variant="subtitle1">
                  <FormattedMessage
                    id="signalPreferences.citiesTitle"
                    defaultMessage="Select Cities"
                  />
                </Typography>
                <Typography variant="body1">
                  <FormattedMessage
                    id="signalPreferences.citiesDescription"
                    defaultMessage="In which city is your business located?"
                  />

                  <br />
                  <FormattedMessage
                    id="signalPreferences.note"
                    defaultMessage="Note: You can select more than one"
                  />
                </Typography>
              </Box>
              <Box my={2}>
                <Autocomplete
                  multiple
                  id="cities-tags"
                  options={Cities.map((city) => city.name.trim())}
                  getOptionLabel={(option) => (option ? option : "")}
                  filterSelectedOptions
                  size="medium"
                  value={
                    companyData && companyData.cities.length > 0
                      ? companyData.cities
                      : []
                  }
                  getOptionSelected={(option, value) => option === value}
                  onChange={handleCityChange}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      placeholder="Add City"
                    />
                  )}
                />
              </Box>
              <Box my={4} textAlign="center">
                <Button
                  variant="contained"
                  color="primary"
                  endIcon={<SendFill />}
                  onClick={handlePostPreferences}
                >
                  <FormattedMessage
                    id="signalPreferences.button.findCandidates"
                    defaultMessage="FIND ME CANDIDATES"
                  />
                </Button>
              </Box>
            </Box>
          )}
          <Snackbar
            open={updatedSuccessfully}
            autoHideDuration={6000}
            onClose={() => setUpdatedSuccessfully(false)}
          >
            <Alert
              onClose={() => setUpdatedSuccessfully(false)}
              severity="success"
            >
              Preferences successfully updated
            </Alert>
          </Snackbar>
        </Fragment>
      )}
    </Container>
  );
};
export default withRouter(SingalPreferences);

const CategoriesHelp = ({ categories, open, onClose }) => {
  const theme = useTheme();
  return (
    <React.Fragment>
      <Slide direction="up" in={open} mountOnEnter unmountOnExit>
        <Container>
          <Box display={"flex"} alignItems="center" my={4}>
            <IconButton
              onClick={() => onClose(false)}
              size="small"
              color="primary"
            >
              <CloseRoundedIcon />
            </IconButton>
            <Typography
              color="primary"
              variant="h5"
              style={{ marginLeft: theme.spacing(2) }}
            >
              Employee Categories
            </Typography>
          </Box>
          <Divider />
          <Box my={2}>
            {categories.map((cat) => (
              <Box display={"flex"} alignItems="center" my={2}>
                <img src={cat.icon} alt={cat.name} />
                <Box
                  display={"flex"}
                  flexDirection="column"
                  style={{ marginLeft: theme.spacing(2) }}
                >
                  <Typography variant="subtitle1">{cat.name}</Typography>
                  <Typography variant="body1" color="textSecondary">
                    {CategoriesMapping(cat.id).join(", ")}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>
        </Container>
      </Slide>
    </React.Fragment>
  );
};
